import React from 'react'
import AddNewSyndicator from 'containers/Syndicators/AddNewSyndicator'

const NewSyndicatorPage = () => <AddNewSyndicator />

export default NewSyndicatorPage
